
<template>
  <div class="workbench_top_style">
    <div class="meunLeft">
      <div class="logoHDY">
        <img src="@/assets/svg/haidayuan.svg" style="vertical-align: middle" />
      </div>
    </div>
    <div class="meunMiddleS">
      <div class="menu_main">
        <div class="menu_item" :class="navClass === 'role' ? 'menu_hover' : ''" @click="clickFun('role')">权限控制</div>
        <div class="menu_item" :class="navClass === 'note' ? 'menu_hover' : ''" @click="clickFun('note')">系统通知</div>
        <div class="menu_item" :class="navClass === 'log' ? 'menu_hover' : ''" @click="clickFun('log')">登录日志</div>
      </div>
    </div>
    <div class="menuRight">
      <div class="menuRight2">
        <div class="menuRight2_text">
          控制中心
        </div>
      </div>
      <div class="menuRight3">
        <img class="menuRight3_image" src="@/assets/svg/user.svg" align="center" style="height: 21px; width: 21px;" />
        <div class="menuRight3_text" @mouseenter="name = '退出'" @mouseleave="name = '系统管理员'" @click="logOutFun()">{{ name }}</div>
      </div>
    </div>
  </div>
  <div class="content-view" v-loading="iframeLoading">
    <iframe :name="iframeCenterSqm" id="iframeCenter" class="iframe" :src="url" width="100%" height="100vh" :key='url'></iframe>
  </div>
</template>

<script>
import { defineComponent, onMounted, ref,getCurrentInstance,watch,nextTick, onUnmounted } from 'vue';
import { useRoute,useRouter } from 'vue-router';

export default defineComponent({
  name: 'CenterSqm',
  setup() {
    const { proxy } = getCurrentInstance()
    const url = ref();
    const iframeLoading = ref(false)
    const iframeCenterSqm = ref(localStorage.getItem('token'))
    const queryData = ref({})
    const SQM_LATEST = ref({})
    const SQM_SELF = ref({})
    const navClass = ref('role')
    const name = ref('系统管理员')
    const router = useRouter()

    const createUrl = (type) => {
      url.value = `${SQM_LATEST.value}#/Content/CenterRole`
      console.log(url.value)
    };
    const clickFun = (type) => {
      if(type === 'role'){
        navClass.value = 'role'
        if(url.value !=`${SQM_LATEST.value}#/Content/CenterRole`){
          url.value = `${SQM_LATEST.value}#/Content/CenterRole`
        }
      }else if (type === 'note'){
        navClass.value = 'note'
        if(url.value !=`${SQM_SELF.value}#/SystemNoticeAdmin?isAdmin=true`){
          url.value = `${SQM_SELF.value}#/SystemNoticeAdmin?isAdmin=true`
        }
        console.log(url.value)

      }else if (type === 'log'){
        navClass.value = 'log'
        if(url.value !=`${SQM_SELF.value}#/logList?isAdmin=true`){
          url.value = `${SQM_SELF.value}#/logList?isAdmin=true`
        }
        console.log(url.value)
      }
    }
    const logOutFun = () =>{
      localStorage.clear()
      router.push({
        path:'/'
      })
    }

    onMounted(() => {
      // 权限校验：只有 sqm00988_admin 用户登录后才能访问
      const loginStatus = localStorage.getItem('sqm_is_logged_in')
      if (loginStatus !== 'no_need_login') {
        router.replace({ path: '/' })
        return
      }

      let isHdy = top == self ? top.location.host.includes('hdy.haier.net') : false
      if(process.env.NODE_ENV === 'development'){
        // 本地多项目 调试
        SQM_LATEST.value = true ? 'https://pre-proxy-sqm-front.hwork.haier.net/sqm/' : 'http://localhost:9550/sqm/'
        SQM_SELF.value = '/sqm-workcbench/'
      }else if(process.env.NODE_ENV === 'production'){
        SQM_LATEST.value = 'https://sqmnew.haier.net/sqm/'
        SQM_SELF.value = isHdy ? 'https://hdy.haier.net/hmqm/' : 'https://sqm.haier.net/workBench/'
      }else{
        SQM_LATEST.value = 'https://pre-proxy-sqm-front.hwork.haier.net/sqm/'
        SQM_SELF.value = isHdy ? 'https://test-hdy.haier.net/sqm-workbench/' : 'https://pre-proxy-sqm-front.hwork.haier.net/sqm-workbench/'
      }
      createUrl();
      
    });

    return {
      iframeLoading,
      iframeCenterSqm,
      url,
      navClass,
      clickFun,
      logOutFun,
      name
    };
  }
});
</script>

<style scoped lang="scss">
.content-view {
  width: 100%;
  height: calc(100vh - 70px);

  .iframe {
    height: calc(100vh - 75px);
    border: 0;
  }
}
.workbench_top_style{
  margin-bottom: 8px;
      width: 100%;
      height: 60px;
      background-color: #386DFF;
      display: flex;
      flex-flow: row;
      .meunLeft{
        padding-left: 10px;
        line-height: 60px;
        .logoHDY{
          cursor: pointer;
        }
      }
      .meunMiddleB{
        width: calc(100vw - 200px - 370px);
        height: 60px;
      }
      .meunMiddleS{
        width: calc(100vw - 200px - 220px);
        height: 60px;
        .menu_main{
          display:flex;
          padding-left: 20px;
          .menu_item{
            height: 35px;
            width: 100px;
            color: #fff;
            border-radius: 6px;
            display: inline-flex;
            align-items: center;
            padding: 8px 16px;
            box-sizing: border-box;
            margin: 12px;
            transition: all 200ms ease-in-out;
            font-size: 14px;
            font-weight: 600;
            cursor: pointer;
          }
          .menu_item:hover{
            color: #3471FF;
            background-color: #fff;
          }
          .menu_hover{
            color: #3471FF;
            background-color: #fff;
          }
        }
      }
      .menuRight{
        display: inline-flex;
        height: 60px;
        font-size: 16px;
        color: #FFF;

        .menuRight2{
          height: 20px;
          width: 100px;
          line-height: 20px;
          margin-top: 20px;
          display: flex;
          .menuRight2_text{
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            width: 75%;
            height: 20px;
          }
          .menuRight2_down{
            cursor: pointer;
            transform: rotate(135deg);
            border-top: 1px solid #FFF;
            border-right: 1px solid #FFF;
            height: 14px;
            width: 14px;
            height: 8px;
            width: 8px;
            margin-left: 5px;
            margin-top: 5px;
          }
        }
        .menuRight3{
          display: flex;
          height: 40px;
          max-width: 300px;
          min-width: 110px;
          padding-right: 10px;
          margin-top: 20px;
          .menuRight3_image{
            padding-right: 5px;
          }
          .menuRight3_text{
            display: block;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            cursor: pointer;
            height: 20px;
          }
          .menuRight3_text:hover{
            white-space: normal;
            line-height: 20px;
            background: #fff;
            color: #3471FF;
            border-radius: 6px;
            padding-right: 5px;
            padding-left: 5px;
          }
        }
        .menuRight3::before{
          content: '|';
          color: #FFF;
          padding-right: 5px;
          height: 20px;
        }
      }
    }
</style>